import { render, staticRenderFns } from "./fccBotoesNavegacao.vue?vue&type=template&id=5d799da4"
import script from "./fccBotoesNavegacao.vue?vue&type=script&lang=js"
export * from "./fccBotoesNavegacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports